import { render, staticRenderFns } from "./Simple.vue?vue&type=template&id=9b2b2ee0&scoped=true&"
var script = {}
import style0 from "./Simple.vue?vue&type=style&index=0&id=9b2b2ee0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b2b2ee0",
  null
  
)

export default component.exports